import { FC } from 'react';

interface LinkProps {
  link?: string;
  children: React.ReactNode;
}

export const Link: FC<LinkProps> = ({ link, children }) => {
  if (!link) return <>{children}</>;

  return (
    <a href={link} target={link.includes('http') ? '_blank' : '_self'} rel='noreferrer noopener'>
      {children}
    </a>
  );
};
